'use client';

import React, { useRef, useLayoutEffect } from 'react';
import cx from 'classnames';

import { createGliderContainer } from '@/utils/slide';

import './index.css';

export type GliderProps = {
  className?: string;
  children: React.ReactNode;
};

const gliderStyles: React.CSSProperties = {
  top: 0,
  width: '2rem',
  height: '100%',
  backgroundColor: 'rgba(255,255,255,0.8)',
};

const Glider = ({ children, className }: GliderProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const gliderRef = createGliderContainer(containerRef.current!);

    return () => gliderRef?.destroy();
  }, []);

  const wrapperClassNames = cx('glider-contain overflow-hidden', className);

  return (
    <div className={wrapperClassNames}>
      <div className='relative'>
        <div className='glider' ref={containerRef}>
          {children}
        </div>
        <button
          type='button'
          aria-label='Anterior'
          className='glider-prev text-black'
          style={{ ...gliderStyles, left: 0 }}
        >
          <svg
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path d='M15 19l-7-7 7-7' />
          </svg>
        </button>
        <button
          type='button'
          aria-label='Próximo'
          className='glider-next text-black'
          style={{ ...gliderStyles, right: 0 }}
        >
          <svg
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path d='M9 5l7 7-7 7' />
          </svg>
        </button>
      </div>
      <div role='tablist' className='dots pt-6' />
    </div>
  );
};

export default Glider;
